import type { GlossaryEntry } from "../../../glossary";
import {
  HYDRATE_GLOSSARY,
  SAVE_GLOSSARY_ENTRY_SUCCESS,
} from "../types";

export interface GlossaryState {
  entries: Record<string, GlossaryEntry>;
  loaded: boolean;
}

const initialState: GlossaryState = {
  entries: {},
  loaded: false,
};

type GlossaryAction =
  | { type: typeof HYDRATE_GLOSSARY; entries: Record<string, GlossaryEntry> }
  | {
      type: typeof SAVE_GLOSSARY_ENTRY_SUCCESS;
      entryKey: string;
      entry: GlossaryEntry;
    };

const glossaryReducer = (state = initialState, action: GlossaryAction): GlossaryState => {
  switch (action.type) {
    case HYDRATE_GLOSSARY:
      return { entries: action.entries, loaded: true };
    case SAVE_GLOSSARY_ENTRY_SUCCESS:
      return {
        ...state,
        entries: {
          ...state.entries,
          [action.entryKey]: action.entry,
        },
      };
    default:
      return state;
  }
};

export default glossaryReducer;
